import React from 'react';
import Icon from '../../../components/AppIcon';

const OutstandingInvoices = ({ invoices = [], loading = false }) => {
  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date?.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const getStatusColor = (status) => {
    const colorMap = {
      'generated': 'text-warning bg-warning/10',
      'sent': 'text-accent bg-accent/10',
      'paid': 'text-success bg-success/10',
      'cancelled': 'text-error bg-error/10'
    };
    return colorMap?.[status] || 'text-muted-foreground bg-muted/10';
  };

  const getStatusLabel = (status) => {
    const labelMap = {
      'generated': 'Generada',
      'sent': 'Enviada',
      'paid': 'Pagada',
      'cancelled': 'Cancelada'
    };
    return labelMap?.[status] || status;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="FileText" size={24} className="text-warning" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Facturas Pendientes
        </h2>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto scroll-smooth">
        {loading ? (
          <div className="flex justify-center py-8">
            <Icon name="Loader2" className="w-6 h-6 text-blue-600 animate-spin" />
          </div>
        ) : invoices?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-2" />
            <p className="text-sm caption text-muted-foreground">
              No hay facturas pendientes
            </p>
          </div>
        ) : (
          invoices?.map((invoice) => (
            <div
              key={invoice?.id}
              className="flex items-center justify-between p-3 rounded-lg border border-border hover:bg-muted/50 transition-smooth"
            >
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <p className="text-sm font-body font-medium text-foreground">
                    {invoice?.invoiceNumber}
                  </p>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${getStatusColor(invoice?.status)}`}>
                    {getStatusLabel(invoice?.status)}
                  </span>
                </div>
                <p className="text-xs caption text-muted-foreground mb-1">
                  {invoice?.clientName}
                </p>
                <div className="flex items-center gap-2 text-xs caption text-muted-foreground">
                  <Icon name="Calendar" size={12} />
                  <span>{formatDate(invoice?.generatedAt)}</span>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-heading font-bold text-foreground">
                  {formatCurrency(invoice?.total)}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default OutstandingInvoices;